import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';
import { __ } from '@wordpress/i18n';
import {
  Affix,
  Button,
  Drawer,
  Empty,
  List,
  message,
  Slider,
  Spin,
  Tooltip,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Draggable from 'react-draggable';
import cx from 'classnames';
import {
  isMobile,
  isMobileOnly,
  isTablet,
  isDesktop,
} from 'react-device-detect';

import './styles.module.scss';
import styles from './catalogue-info.module.scss';
import AppHelper from 'libs/AppHelper';
import whttp from 'libs/whttp';
import { API_HOST } from 'configs/env';

const VC_CONFIG = _.get(window, 'VC_CONFIG');
const PLUGIN_ASSETS_URL = VC_CONFIG.PLUGIN_ASSETS_URL;
const isDoublePageMode = (width) => width > 992;

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [
    {
      name: '品牌 #1',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/48859859abcf9248f23d4f6202efcf5f.jpg",
    },
    {
      name: '品牌 #2',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/251b9bce1f9a454ae691944ea9396e31.jpg",
    },
    {
      name: '品牌 #3',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/f63176e067072961ddd5a17e7ecb61fe.jpg"
    },
    {
      name: '品牌 #4',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/252716bd6a210aa82c3a09c2a62833e9.jpg",
    },
  ],
};

const InfoDetail = () => {
  return (
    <div className={`${styles['info-card']}`}>
      <h6 class='h6 text-primary text-center mb-3'>促銷目錄說明</h6>
      <p class='p mb-0 text-primary text-justify'>
        本促銷目錄之價格、圖片及贈品若有誤，以賣場實際標示為準。
        <br />
        促銷目錄之商品，因各賣場規模不同，部份分店未販售或僅販售部份商品，該店販售品項，請依賣場陳列為準。{' '}
        <br />
        為響應環保，如果您欲取消紙本促銷目錄郵寄，請聯絡客服中心免付費專線：0809-001-365
        (服務時間：上午9點~晚間9點)
      </p>
    </div>
  )
};

export default class CatalogueInfo extends Component {
  previewHeight = null;
  previewHeightSet = true;

  state = {
    catalogueInfo: {
      images: [],
      images_previews: [],
      imagesPreviewsDoublePage: [],
    },
    data: [],
    loading: false,
    hasMore: true,
    currentSlideIdx: 0,
    query: {},
    isModalVisible: true,
    isModalVisibleInfo: false,
    zoomPreviewImg: 1,
    zoomModalImg: 1,
    deviceWidth: window.innerWidth,
    modalImageList: [],
    modalImagePosition: { x: 0, y: 0 },
    categoryIdxDrawer: false,
    categoryIdxDrawerModal: false,
  };

  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    this.setState({ query });
    this.loadData();
    this.GTM();
    this.setBackToTopAnchor();
    // this.setModalImgMouseWheel();

    window.addEventListener('resize', (e) => {
      const { deviceWidth, currentSlideIdx } = this.state;
      const previousWidth = deviceWidth;
      const currentWidth = e.target.innerWidth;

      if (
        (!isDoublePageMode(previousWidth) && !isDoublePageMode(currentWidth)) ||
        (isDoublePageMode(previousWidth) && isDoublePageMode(currentWidth))
      ) {
        this.setState({
          deviceWidth: currentWidth,
        });
        return;
      }

      this.setState(
        {
          deviceWidth: currentWidth,
          modalImageList: [],
          currentSlideIdx: isDoublePageMode(currentWidth)
            ? Math.ceil(currentSlideIdx / 2)
            : currentSlideIdx * 2 - 1,
        },
        () => {
          this.reloadSwiper();
          this.reloadSwiperModal();
        }
      );
    });

    // post message, iframe receive message listener
    window.addEventListener('message', this.receiveMessage, false);
  }

  receiveMessage = (event) => {
    if (event.origin !== 'https://edm.cec-taiwan.com.tw') {
      return false;
    }
    const height = event.data;
    document.getElementById('edm-iframe').setAttribute('height', height);
  };

  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document).on('click', '#pdf', function() {
      var $text = $(this).attr('alt');
      dataLayer.push({
        event: 'catalogue_pdf',
        item: $text,
      });
    });
  };

  loadData = () => {
    const search = _.get(window, 'location.search');
    const queryParams = qs.parse(search);
    const catalogue = queryParams.catalogue;
    const { deviceWidth } = this.state;

    if (!catalogue) return;

    this.setState({ isFetchData: true });
    whttp.get(
      API_HOST + `/api/v1/catalogues/${catalogue}`,
      null,
      (state, res) => {
        this.setState({ isFetchData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace('/catalogues');
          return;
        }

        // 改原圖片
        // const imagesPreviewsDoublePage = data.images_previews
        //   .map((img, idx) => {
        //     if (idx === 0 || idx === data.images_previews.length - 1) {
        //       return [img]
        //     }
        //     if (idx % 2 !== 0) {
        //       return [img, data.images_previews[idx + 1]]
        //     }
        //     return null
        //   })
        //   .filter(Boolean)
        const imagesPreviewsDoublePage = data.images
          .map((img, idx) => {
            if (idx === 0 || idx === data.images.length - 1) {
              return [img];
            }
            if (idx % 2 !== 0) {
              return [img, data.images[idx + 1]];
            }
            return null;
          })
          .filter(Boolean);

        this.setState({
          catalogueInfo: {
            ...data,
            imagesPreviewsDoublePage,
          },
        });
        // 改原圖片
        // this.setCurrentSlideIdx(data.images_previews, imagesPreviewsDoublePage)
        this.setCurrentSlideIdx(data.images, imagesPreviewsDoublePage);
        this.handleInfiniteOnLoad();
        this.reloadSwiper();
        this.reloadSwiperModal();
      }
    );
  };

  setCurrentSlideIdx = (singlePageList, doublePageList) => {
    const { deviceWidth } = this.state;
    const { page } = qs.parse(window.location.hash);
    const queryPage = Number(page);
    let imgIdx =
      Number.isNaN(queryPage) ||
      queryPage <= 0 ||
      queryPage > singlePageList.length
        ? 0
        : queryPage - 1;
    const imgURL = singlePageList[imgIdx];

    if (isDoublePageMode(deviceWidth)) {
      imgIdx = doublePageList.findIndex((a) => a.includes(imgURL));
    } else {
      imgIdx = singlePageList.findIndex((a) => a === imgURL);
    }

    this.setState({ currentSlideIdx: imgIdx });
  };

  getDeviceType = () => {
    return {
      isDesktop: isDesktop && window.orientation === 0,
      isTabletPortrait: isTablet && window.orientation === 0,
      isTabletLandscape: isTablet && [-90, 90].includes(window.orientation),
      isMobilePortrait: isMobileOnly && window.orientation === 0,
      isMobileLandscape: isMobileOnly && [-90, 90].includes(window.orientation),
    };
  };

  setBackToTopAnchor = () => {
    const backToTopAnchor = document.querySelector('.back_to_top');
    backToTopAnchor.style.display = 'none';
    window.addEventListener(
      'scroll',
      _.throttle((e) => {
        if (window.scrollY > 400) {
          backToTopAnchor.style.display = 'block';
        } else {
          backToTopAnchor.style.display = 'none';
        }
      }),
      500
    );
  };

  handleInfiniteOnLoad = (page) => {
    const catalogueInfo = _.get(this.state, 'catalogueInfo');

    this.setState({ loading: true });

    setTimeout(() => {
      const data = _.get(this, 'state.data', []);
      const newData = _.slice(
        _.get(catalogueInfo, 'images'),
        0,
        data.length + 1
      );
      this.setState({
        loading: false,
        data: newData,
        hasMore: data.length < newData.length,
      });
    }, 100);
  };

  reloadSwiper = () => {
    const Swiper = window.Swiper;
    if (!Swiper) return;
    window.swiperCatalog = new Swiper('.catalogs-slide .swiper-container', {
      initialSlide: this.state.currentSlideIdx,
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: '.next-btn',
        prevEl: '.previous-btn',
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      watchSlidesVisibility: true,
      threshold: 5,
    });

    window.swiperCatalog.on('slideChange', () => {
      this.setState({
        currentSlideIdx: window.swiperCatalog.activeIndex,
      });
    });

    window.swiperCatalog.on('lazyImageReady', (swiper, slideEl, imageEl) => {
      slideEl.style.visibility = 'visible';
    });
  };

  reloadSwiperModal = () => {
    const Swiper = window.Swiper;
    if (!Swiper) return;
    window.swiperCatalogModal = new Swiper('.swiper-container-modal', {
      initialSlide: this.state.currentSlideIdx,
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: '.swiper-container-modal .next-btn',
        prevEl: '.swiper-container-modal .previous-btn',
      },
      preloadImages: false,
      lazy: { loadPrevNext: true },
      watchSlidesVisibility: true,
      threshold: 5,
      spaceBetween: (window.innerWidth - window.innerWidth * 0.95) / 2,
      centeredSlides: true,
    });

    window.swiperCatalogModal.on('slideChange', () => {
      this.setState(
        {
          currentSlideIdx: window.swiperCatalogModal.activeIndex,
        },
        () => {
          window.swiperCatalog.slideTo(this.state.currentSlideIdx);
        }
      );
    });

    window.swiperCatalogModal.on(
      'lazyImageReady',
      (swiper, slideEl, imageEl) => {
        slideEl.style.visibility = 'visible';
      }
    );
  };

  handleChangeSlider = (e) => {
    if (this.state.zoomPreviewImg === 1) {
      window.swiperCatalog.slideTo(e - 1);
    }
    this.setState({
      currentSlideIdx: e - 1,
      zoomPreviewImg: 1,
    });
  };

  handleOpenModal = () => {
    this.setState(
      {
        isModalVisible: true,
        zoomModalImg: 1,
        modalImagePosition: { x: 0, y: 0 },
      },
      () => {
        this.reloadSwiperModal();
        // this.setModalImgMouseWheel();
      }
    );
  };

  handleCloseModal = (e) => {
    const cxName = e.target.className;
    e.persist();
    if (typeof cxName !== 'string') return;
    if (
      cxName.includes('modal-content-wrapper') ||
      cxName.includes('mask-wrapper') ||
      cxName.includes('swiper-slide') ||
      cxName.includes('catalogs-page-image') ||
      cxName.includes('close-btn')
    ) {
      this.setState({
        isModalVisible: false,
        isModalVisibleInfo: false,
      });
    }
  };

  handleZoomOut = (name) => {
    const zoom = this.state[name];
    if (zoom <= 1) return;
    this.setState({ [name]: zoom - 0.25 }, () => {
      if (this.state[name] === 1) {
        this.reloadSwiper();
        return;
      }
    });
  };

  handleZoomIn = (name) => {
    const zoom = this.state[name];
    if (zoom >= 2) return;
    this.setState({ [name]: zoom + 0.25 });
  };

  handleClickInfoIcon = () => {
    if (!isDesktop) {
      this.setState({ isModalVisibleInfo: true });
    }
  };

  getSliderTipFormat = (value) => {
    const { catalogueInfo, deviceWidth } = this.state;

    const AddZero = (num) => (String(num).length < 2 ? `0${num}` : `${num}`);

    if (!isDoublePageMode(deviceWidth)) {
      // const totalPage = catalogueInfo.images_previews.length
      // 改原圖片
      const totalPage = catalogueInfo.images.length;
      return `${AddZero(value)}/${AddZero(totalPage)}`;
    }

    if (isDoublePageMode(deviceWidth)) {
      const totalPage = catalogueInfo.imagesPreviewsDoublePage.length;
      let countArray = [];
      for (let i = 2; i <= totalPage; i++) {
        countArray.push(i);
      }
      const idx = countArray.findIndex((i) => i === value);

      if (value === 1) {
        return '01';
      }
      if (value === totalPage) {
        return `${AddZero(value + idx)}`;
      }
      return `${AddZero(value + idx)}/${AddZero(value + idx + 1)}`;
    }
  };

  renderSlider = () => {
    const { catalogueInfo, currentSlideIdx, deviceWidth } = this.state;
    // const max = isDoublePageMode(deviceWidth)
    //   ? catalogueInfo.imagesPreviewsDoublePage.length
    //   : catalogueInfo.images_previews.length
    // 改原圖片
    const max = isDoublePageMode(deviceWidth)
      ? catalogueInfo.imagesPreviewsDoublePage.length
      : catalogueInfo.images.length;
    return (
      <Slider
        className={styles['slider']}
        trackStyle={{
          backgroundColor: '#0870e6',
        }}
        handleStyle={{
          border: '3px solid #0870E6',
        }}
        min={1}
        max={max}
        tipFormatter={
          window.innerWidth >= 1024 ? this.getSliderTipFormat : null
        }
        value={currentSlideIdx + 1}
        onChange={this.handleChangeSlider}
      />
    );
  };

  renderPreviewPrevNextBtn = () => {
    const {
      currentSlideIdx,
      deviceWidth,
      catalogueInfo,
      zoomPreviewImg,
    } = this.state;
    const currentPage = currentSlideIdx + 1;
    // const totalPage = isDoublePageMode(deviceWidth)
    //   ? catalogueInfo.imagesPreviewsDoublePage.length
    //   : catalogueInfo.images_previews.length
    // 改原圖片
    const totalPage = isDoublePageMode(deviceWidth)
      ? catalogueInfo.imagesPreviewsDoublePage.length
      : catalogueInfo.images.length;

    const handleNext = () => {
      if (zoomPreviewImg === 1) return;
      this.setState(
        (prevState, props) => ({
          currentSlideIdx: prevState.currentSlideIdx + 1,
          zoomPreviewImg: 1,
        }),
        () => {
          this.reloadSwiper();
        }
      );
    };

    const handlePrev = () => {
      if (zoomPreviewImg === 1) return;
      this.setState(
        (prevState, props) => ({
          currentSlideIdx: prevState.currentSlideIdx - 1,
          zoomPreviewImg: 1,
        }),
        () => {
          this.reloadSwiper();
        }
      );
    };

    return (
      <Fragment>
        <div className={styles['next-btn-wrapper']}>
          <div
            class='next-btn'
            style={{
              visibility: currentPage !== totalPage ? 'visible' : 'hidden',
            }}
            onClick={handleNext}
          />
        </div>
        <div className={styles['prev-btn-wrapper']}>
          <div
            class='previous-btn'
            style={{
              visibility: currentPage !== 1 ? 'visible' : 'hidden',
            }}
            onClick={handlePrev}
          />
        </div>
      </Fragment>
    );
  };

  handleClickModalArrowBtn = (mode) => {
    const { currentSlideIdx } = this.state;
    const { activeIndex } = window.swiperCatalog;
    const isNext = mode === 'next';

    window.swiperCatalog.slideTo(isNext ? activeIndex + 1 : activeIndex - 1);
    this.setState({
      currentPage: isNext ? currentSlideIdx + 1 : currentSlideIdx - 1,
      modalImagePosition: { x: 0, y: 0 },
      zoomModalImg: 1,
    });
  };

  getPageInfo = (currentSlide) => {
    let products = [];
    if (!currentSlide) return products;
    if (Array.isArray(currentSlide)) {
      currentSlide.forEach((url) => {
        const imgUrl = url.split('_preview').join('');
        const info = this.state.catalogueInfo.page_info.find(
          (obj) => obj.image === imgUrl
        );
        if (!info || !info.products) return products;
        products = [...products, ...info.products];
      });
    } else {
      const imgUrl = currentSlide.split('_preview').join('');
      const info = this.state.catalogueInfo.page_info.find(
        (obj) => obj.image === imgUrl
      );
      if (!info || !info.products) return products;
      products = [...products, ...info.products];
    }
    return products;
  };

  setModalImage = (imgURL) => {
    const { modalImageList, zoomModalImg } = this.state;
    const { isMobileLandscape } = this.getDeviceType();
    const image = modalImageList.find((m) => m.url === imgURL);

    if (!image) {
      const img = new Image();
      img.src = imgURL;

      img.addEventListener('load', (e) => {
        const image = e.path ? e.path[0] : e.target;
        let imgHeight = null;
        let imgWidth = null;

        if (window.innerWidth > window.innerHeight) {
          imgHeight = Math.round((window.innerHeight - 100) * 0.9);
          imgWidth = Math.round(imgHeight * (image.width / image.height));
        }

        if (window.innerHeight > window.innerWidth) {
          imgWidth = Math.round(window.innerWidth * 0.95);
          imgHeight = Math.round(imgWidth * (image.height / image.width));
        }

        if (isMobileLandscape) {
          imgWidth = Math.round(window.innerWidth * 0.95);
          imgHeight = Math.round(imgWidth * (image.height / image.width));
        }

        this.setState({
          modalImageList: [
            ...modalImageList,
            {
              url: imgURL,
              width: imgWidth,
              height: imgHeight,
            },
          ],
        });
      });
    }
  };

  getModalImage = (imgURL) => {
    const { modalImageList, zoomModalImg } = this.state;
    let img = modalImageList.find((m) => m.url === imgURL) || {};
    return {
      ...img,
      width: img.width * zoomModalImg,
      height: img.height * zoomModalImg,
    };
  };

  handleStopModalImage = (e, data) => {
    this.setState({
      modalImagePosition: {
        x: data.x,
        y: data.y,
      },
    });
  };

  renderCategoryIdxBtn = (type = '') => {
    const { categoryIdxDrawer, categoryIdxDrawerModal } = this.state;
    const btnStyle =
      (categoryIdxDrawer && type === '') ||
      (categoryIdxDrawerModal && type === 'modal');

    const btnCx = cx({
      [styles['category-idx-btn']]: true,
      [styles['opened']]: btnStyle,
    });

    const btnIconSrc = `${PLUGIN_ASSETS_URL}img/catalog/index-${
      btnStyle ? 'open' : 'close'
    }.svg`;

    const handleClickCategoryIndex = () => {
      const scrollY = window.scrollY;
      if (type === 'modal') {
        this.setState({
          categoryIdxDrawerModal: !categoryIdxDrawerModal,
        });
      } else {
        this.setState(
          {
            categoryIdxDrawer: !categoryIdxDrawer,
          },
          () => {
            window.scroll(0, scrollY);
          }
        );
      }
    };

    return (
      <div className={btnCx} onClick={handleClickCategoryIndex}>
        目錄索引
        <img class='ml-2' src={btnIconSrc} alt='' />
      </div>
    );
  };

  handleCloseDrawer = () => {
    this.setState({ categoryIdxDrawer: false, categoryIdxDrawerModal: false });
  };

  handleClickCategory = (page) => {
    const {
      catalogueInfo,
      deviceWidth,
      zoomPreviewImg,
      categoryIdxDrawer,
      categoryIdxDrawerModal,
      isModalVisible,
    } = this.state;
    // const imgList = isDoublePageMode(deviceWidth)
    //   ? catalogueInfo.imagesPreviewsDoublePage.flat()
    //   : catalogueInfo.images_previews
    // 改原圖片
    const imgList = isDoublePageMode(deviceWidth)
      ? catalogueInfo.imagesPreviewsDoublePage.flat()
      : catalogueInfo.images;
    const url = imgList[page - 1] ? imgList[page - 1] : imgList[0];

    let slideIdx = null;
    if (page > imgList.length) {
      // slideIdx = isDoublePageMode(deviceWidth)
      //   ? catalogueInfo.imagesPreviewsDoublePage.length - 1
      //   : catalogueInfo.images_previews.length - 1
      // 改原圖片
      slideIdx = isDoublePageMode(deviceWidth)
        ? catalogueInfo.imagesPreviewsDoublePage.length - 1
        : catalogueInfo.images.length - 1;
    } else if (isDoublePageMode(deviceWidth)) {
      catalogueInfo.imagesPreviewsDoublePage.forEach((ary, idx) => {
        if (ary.includes(url)) {
          slideIdx = idx;
          return;
        }
      });
    } else {
      slideIdx = page - 1;
    }

    if (zoomPreviewImg === 1) {
      window.swiperCatalog.slideTo(slideIdx);
    }
    if (!isDesktop && categoryIdxDrawerModal) {
      window.swiperCatalogModal.slideTo(slideIdx);
    }

    this.setState(
      {
        currentSlideIdx: slideIdx,
        zoomPreviewImg: 1,
        categoryIdxDrawer:
          isMobile && categoryIdxDrawer && !isModalVisible
            ? false
            : categoryIdxDrawer,
      },
      () => {
        if (zoomPreviewImg !== 1) {
          this.reloadSwiper();
        }
      }
    );
  };

  renderDrawerList = () => {
    const { catalogueInfo } = this.state;
    const categoryIndexesList = catalogueInfo.category_indexes || [];

    const nameTransform = (name) => {
      return name.match(/.{1,8}/g).map((n) => (
        <Fragment>
          {n}
          <br />
        </Fragment>
      ));
    };

    return (
      <div className={styles['drawer-category-list']}>
        {categoryIndexesList.map((c) => {
          const page = c.page;
          return (
            <div
              className={styles['drawer-category']}
              onClick={() => this.handleClickCategory(page)}
            >
              <div>{nameTransform(c.index_name)}</div>
              <div>{String(c.page).length === 1 ? `0${c.page}` : c.page}</div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const {
      isTabletPortrait,
      isTabletLandscape,
      isMobilePortrait,
      isMobileLandscape,
    } = this.getDeviceType();

    const {
      catalogueInfo = {},
      currentSlideIdx,
      zoomPreviewImg,
      zoomModalImg,
      isModalVisible,
      isModalVisibleInfo,
      deviceWidth,
      modalImageList,
      modalImagePosition,
    } = this.state;

    const showCategoryIdxBtn =
      catalogueInfo.category_indexes &&
      catalogueInfo.category_indexes.length > 0;
    const catalogsSlideEl = document.querySelector('.catalogs-slide');
    if (this.previewHeightSet && catalogsSlideEl) {
      if (catalogsSlideEl.getBoundingClientRect().height > this.previewHeight) {
        this.previewHeight = catalogsSlideEl.getBoundingClientRect().height;
      }
    }

    const swiper = window.swiperCatalog || {};
    const swiperModal = window.swiperCatalogModal || {};
    const currentPage = currentSlideIdx + 1;
    const pdf = _.get(catalogueInfo, 'pdfs.0') || '';
    const urlQuery = AppHelper.getURLQuery();
    const isKiosk = urlQuery.view;
    const Local = _.get(window, 'VC_CONFIG.Locale');

    // const totalPage = isDoublePageMode(deviceWidth)
    //   ? catalogueInfo.imagesPreviewsDoublePage.length
    //   : catalogueInfo.images_previews.length

    // const imgList = isDoublePageMode(deviceWidth)
    // ? catalogueInfo.imagesPreviewsDoublePage
    // : catalogueInfo.images_previews
    // 改原圖片
    const totalPage = isDoublePageMode(deviceWidth)
      ? catalogueInfo.imagesPreviewsDoublePage.length
      : catalogueInfo.images.length;

    const imgList = isDoublePageMode(deviceWidth)
      ? catalogueInfo.imagesPreviewsDoublePage
      : catalogueInfo.images;

    const havePageinfo = _.get(catalogueInfo, 'page_info', []).length
      ? _.get(catalogueInfo, 'page_info', [])
      : null;

    const hasDoublePage = imgList.every((i) => Array.isArray(i));
    const currentSlide = imgList[currentSlideIdx];
    const isDoublePage = Array.isArray(currentSlide) && currentSlide.length > 1;

    // 是否為iframe頁面
    const iFrameUrl = _.get(catalogueInfo, 'iframe_url', null);

    // 判斷 pageinfo 為 0 = 最後一頁
    let products = [];
    if (currentPage === totalPage) {
      const info = catalogueInfo.page_info.find((obj) => obj.page === 0);
      if (info) {
        products = [...products, ...info.products];
      }
    } else {
      products = this.getPageInfo(currentSlide);
    }

    const enName = _.get(catalogueInfo, 'en_name', [])
      ? _.get(catalogueInfo, 'en_name', [])
      : '';

    if (swiper) {
      swiper.allowTouchMove = zoomPreviewImg === 1;
    }

    if (swiperModal) {
      swiperModal.allowTouchMove = zoomPreviewImg === 1;
    }

    const zoomOutBtnCx = (name) =>
      cx({
        [styles['zoom-out-btn']]: true,
        [styles['disabled']]: this.state[name] === 1,
      });

    const zoomInBtnCx = (name) =>
      cx({
        [styles['zoom-in-btn']]: true,
        [styles['disabled']]: this.state[name] === 2,
      });

    // 設定 Modal Image 長寬
    if (currentSlide && hasDoublePage) {
      currentSlide.forEach((c) => {
        this.setModalImage(c);
      });
    }
    if (currentSlide && !hasDoublePage) {
      this.setModalImage(currentSlide);
    }

    return (
      <main class='bg-light'>
        {isKiosk && (
          <Affix offsetTop={30}>
            <Button
              style={{
                display: 'inline-flex',
                fontSize: '30px',
                color: 'white',
                borderRadius: '20px',
                backgroundColor: '#08c',
                height: '60px',
                width: '140px',
                top: '20px',
                left: '40px',
              }}
              onClick={() => window.history.back()}>
              <ArrowLeftOutlined
                style={{
                  fontSize: '40px',
                  color: 'white',
                  width: '70px',
                }}
              />
              返回
            </Button>
          </Affix>
        )}
        {!isKiosk && (
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol className={`breadcrumb ${styles['breadcrumb']}`}>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${VC_CONFIG.INDEX_URL}${
                        Local == 'en_US' ? '/en' : ''
                      }`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a href={`${VC_CONFIG.INDEX_URL}/catalogues`}>
                      {__('促銷目錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {catalogueInfo.category_id == 40 && (
                    <li class='breadcrumb-item'>
                      <a
                        href={`${
                          VC_CONFIG.INDEX_URL
                        }/catalogues-corrections${
                          Local == 'en_US' ? '-en' : ''
                        }`}>
                        {__('目錄更正公告', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  {catalogueInfo.category_id == 41 && (
                    <li class='breadcrumb-item'>
                      <a
                        href={`${
                          VC_CONFIG.INDEX_URL
                        }/catalogues-preorderitemrules${
                          Local == 'en_US' ? '-en' : ''
                        }`}>
                        {__('預購目錄應記載事項', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  {/* {catalogueInfo.category_id!=(40||41) && <li class="breadcrumb-item"><a href={`${VC_CONFIG.INDEX_URL}/catalogues${Local=="en_US"?"-en":""}`}>{__('全部促銷目錄','cec-plugin-stores')}</a></li> } */}
                  <li
                    class='breadcrumb-item active'
                    aria-current='page'
                    id='name'>
                    {catalogueInfo.name}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        )}
        {havePageinfo && iFrameUrl === null && (
          <Fragment>
            <div class='container' style={{ maxWidth: '1435px' }}>
              <section class='p-0'>
                <div class='row'>
                  <div class='col-lg-9 d-flex flex-column'>
                    <div className={styles['operation-wrapper']}>
                      {showCategoryIdxBtn && (
                        <div style={{ marginRight: 'auto' }}>
                          {this.renderCategoryIdxBtn()}
                        </div>
                      )}
                      <div className={styles['fake-space']} />
                      <div className={styles['slider-wrapper']}>
                        <div className={`${styles['index-wrapper']}`}>
                          {this.getSliderTipFormat(currentPage)}
                        </div>
                        {(isTablet || isMobile) && this.renderSlider()}
                      </div>
                      <div className={styles['function-wrapper']}>
                        <Tooltip
                          overlayClassName={styles['info-tooltip']}
                          title={
                            <Fragment>
                              <h6 class='h6 text-primary text-center mb-3'>
                                促銷目錄說明
                              </h6>
                              <p class='p mb-0 text-primary text-justify'>
                                本促銷目錄之價格、圖片及贈品若有誤，以賣場實際標示為準。
                                <br />
                                促銷目錄之商品，因各賣場規模不同，部份分店未販售或僅販售部份商品，該店販售品項，請依賣場陳列為準。{' '}
                                <br />
                                為響應環保，如果您欲取消紙本促銷目錄郵寄，請聯絡客服中心免付費專線：0809-001-365
                                (服務時間：上午9點~晚間9點)
                              </p>
                            </Fragment>
                          }
                          placement='bottom'>
                          <div
                            className={styles['info-btn']}
                            onClick={this.handleClickInfoIcon}
                          />
                        </Tooltip>
                        {pdf && (
                          <a
                            href={
                              pdf &&
                              pdf.replace(
                                'mppuni-prosperity',
                                'wwwuni-prosperity',
                              )
                            }
                            target='_blank'>
                            <div className={styles['download-btn']} />
                          </a>
                        )}
                        {!isMobileOnly && (
                          <div
                            className={styles['fullscreen-btn']}
                            onClick={this.handleOpenModal}
                          />
                        )}
                      </div>
                      <div
                        className={zoomOutBtnCx('zoomPreviewImg')}
                        onClick={() => this.handleZoomOut('zoomPreviewImg')}
                      />
                      <div
                        className={zoomInBtnCx('zoomPreviewImg')}
                        onClick={() => this.handleZoomIn('zoomPreviewImg')}
                      />
                    </div>
                    {zoomPreviewImg !== 1 && !isDoublePage && (
                      <div
                        className={styles['preview-wrapper']}
                        style={{
                          height: this.previewHeight,
                        }}>
                        <div className={styles['preview-scale-wrapper']}>
                          <div
                            className={
                              styles['preview-scale-inner-wrapper']
                            }
                            style={{
                              transform: `scale(${zoomPreviewImg})`,
                            }}>
                            <Draggable>
                              <div
                                className={styles['preview-image']}
                                style={{
                                  backgroundImage: `url(${currentSlide})`,
                                }}
                              />
                            </Draggable>
                          </div>
                          {this.renderPreviewPrevNextBtn()}
                          <Drawer
                            className={styles['drawer']}
                            width='22%'
                            placement='left'
                            visible={this.state.categoryIdxDrawer}
                            getContainer={false}
                            bodyStyle={{ background: '#0870e6' }}
                            onClose={this.handleCloseDrawer}>
                            {this.renderDrawerList()}
                          </Drawer>
                        </div>
                        <div className={styles['slider-wrapper']}>
                          {this.renderSlider()}
                        </div>
                      </div>
                    )}
                    {zoomPreviewImg !== 1 && isDoublePage && (
                      <div
                        className={styles['preview-wrapper']}
                        style={{
                          height: this.previewHeight,
                        }}>
                        <div className={styles['preview-scale-wrapper']}>
                          <div
                            className={
                              styles['preview-scale-inner-wrapper']
                            }
                            style={{
                              transform: `scale(${zoomPreviewImg})`,
                            }}>
                            <Draggable>
                              <div
                                className={styles['preview-image-wrapper']}>
                                {currentSlide.map((imgURL, idx) => {
                                  return (
                                    <div
                                      className={styles['preview-image']}
                                      style={{
                                        backgroundImage: `url(${imgURL})`,
                                        flexBasis: '50%',
                                        backgroundPosition:
                                          idx === 0 ? 'right' : 'left',
                                      }}
                                    />
                                  )
                                })}
                              </div>
                            </Draggable>
                          </div>
                          {this.renderPreviewPrevNextBtn()}
                          <Drawer
                            className={styles['drawer']}
                            width='22%'
                            placement='left'
                            visible={this.state.categoryIdxDrawer}
                            getContainer={false}
                            bodyStyle={{ background: '#0870e6' }}
                            onClose={this.handleCloseDrawer}>
                            {this.renderDrawerList()}
                          </Drawer>
                        </div>
                        <div className={styles['slider-wrapper']}>
                          {this.renderSlider()}
                        </div>
                      </div>
                    )}
                    {zoomPreviewImg === 1 &&
                      !isDoublePageMode(deviceWidth) && (
                        <div
                          class='catalogs-slide pb-0 d-flex flex-column'
                          style={{
                            paddingTop: isMobile ? '0px' : 'inherit',
                            height: isTablet ? '426px' : 'auto',
                          }}>
                          <Fragment>
                            <div
                              class='swiper-container w-100'
                              style={{
                                height: isMobileLandscape
                                  ? '253px'
                                  : 'auto',
                              }}>
                              <div
                                class='swiper-wrapper h-100'
                                style={{ alignItems: 'center' }}>
                                {/* {catalogueInfo.images_previews.map((imgURL) => {
                                return (
                                  <div class='swiper-slide'>
                                    <div class='catalogs-page-image w-100 h-100'>
                                      <img
                                        data-src={imgURL}
                                        alt=''
                                        class='swiper-lazy'
                                        style={{
                                          visibility: 'hidden',
                                        }}
                                      />
                                      <div class='swiper-lazy-preloader' />
                                    </div>
                                  </div>
                                )
                              })} */}
                                {/* 改原地址 */}
                                {catalogueInfo.images.map((imgURL) => {
                                  return (
                                    <div class='swiper-slide'>
                                      <div class='catalogs-page-image w-100 h-100'>
                                        <img
                                          data-src={imgURL}
                                          alt=''
                                          class='swiper-lazy'
                                          style={{
                                            visibility: 'hidden',
                                          }}
                                        />
                                        <div class='swiper-lazy-preloader' />
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                              {this.renderPreviewPrevNextBtn()}
                              <Drawer
                                className={styles['drawer']}
                                width='22%'
                                placement='left'
                                visible={this.state.categoryIdxDrawer}
                                getContainer={false}
                                bodyStyle={{ background: '#0870e6' }}
                                onClose={this.handleCloseDrawer}>
                                {this.renderDrawerList()}
                              </Drawer>
                            </div>
                            <div className={styles['slider-wrapper']}>
                              <div className={styles['index-wrapper']}>
                                {this.getSliderTipFormat(currentPage)}
                              </div>
                              {this.renderSlider()}
                              <div
                                className={styles['fullscreen-icon']}
                                onClick={this.handleOpenModal}
                              />
                            </div>
                          </Fragment>
                        </div>
                      )}
                    {zoomPreviewImg === 1 && isDoublePageMode(deviceWidth) && (
                      <div
                        class='catalogs-slide pb-0 d-flex flex-column'
                        style={{
                          height: 'auto',
                          overflow: 'hidden',
                        }}>
                        <Fragment>
                          <div
                            class='swiper-container w-100'
                            style={{
                              height: isDesktop ? '90%' : '100%',
                            }}>
                            <div class='swiper-wrapper h-100'>
                              {catalogueInfo.imagesPreviewsDoublePage.map(
                                (imgArray) => {
                                  return (
                                    <div class='swiper-slide'>
                                      <div class='catalogs-page-image h-100'>
                                        {imgArray.map((url, idx) => {
                                          return (
                                            <img
                                              data-src={url}
                                              alt=''
                                              class='swiper-lazy'
                                              style={{
                                                visibility: 'hidden',
                                                width: '50%',
                                                objectPosition:
                                                  imgArray.length === 1
                                                    ? 'center'
                                                    : idx % 2 === 0
                                                    ? 'right'
                                                    : 'left',
                                              }}
                                            />
                                          )
                                        })}
                                        <div class='swiper-lazy-preloader' />
                                      </div>
                                    </div>
                                  )
                                },
                              )}
                            </div>
                            {this.renderPreviewPrevNextBtn()}
                            <Drawer
                              className={styles['drawer']}
                              width='22%'
                              placement='left'
                              visible={this.state.categoryIdxDrawer}
                              getContainer={false}
                              bodyStyle={{ background: '#0870e6' }}
                              onClose={this.handleCloseDrawer}>
                              {this.renderDrawerList()}
                            </Drawer>
                          </div>
                          <div className={styles['slider-wrapper']}>
                            <div className={styles['index-wrapper']}>
                              {this.getSliderTipFormat(currentPage)}
                            </div>
                            {this.renderSlider()}
                            <div
                              className={styles['fullscreen-icon']}
                              onClick={this.handleOpenModal}
                            />
                          </div>
                        </Fragment>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      styles['slide-product-wrapper']
                    } col-lg-3 col-sm-12`}>
                    <div
                      className={`${
                        styles['slide-product-column']
                      } overflow-lg-hidden position-absolute h-lg-100 p-0 d-flex flex-column`}>
                      <div
                        class='bg-sea p-4 mb-4'
                        style={{
                          borderRadius: '10px',
                        }}>
                        <p class='note text-primary text-center mb-0'>
                          商品價格如有更動，以賣場與線上購物網站標示為準
                        </p>
                      </div>
                      <div
                        className={`${
                          styles['product-list-wrapper']
                        } px-lg-4 px-sm-2 py-2 overflow-auto `}>
                        {(products.length === 0 ||
                          products.every(
                            (product) => !product.IsOnSale,
                          )) && (
                          <div class='d-flex justify-content-center h-100'>
                            <div class='col-lg-12 col-md-9'>
                              <div class='d-flex flex-column justify-content-center h-100'>
                                <div class='row'>
                                  <div className={styles['product-list-empty-img']}>
                                    <img src={`${PLUGIN_ASSETS_URL}img/catalogue/logo.png`} alt="更多活動資訊請至實體賣場或線上購物"></img>
                                  </div>
                                  <p class='w-100 p text-font text-center mb-5'>
                                    更多活動資訊請至實體賣場或線上購物
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {_.map(products, (item, idx) => {
                          if (item.IsOnSale) {
                            return (
                              <div
                                className={`${
                                  styles['card-wrapper']
                                } card border-0 rounded-10`}>
                                <a
                                  href={`${
                                    item.uri
                                  }?utm_campaign=${enName}&utm_medium=dm&utm_source=web`}
                                  target='_blank'
                                  rel='noopener noreferrer'>
                                  <div class='card-body'>
                                    <div class='row'>
                                      <div class='col-4 d-flex align-items-center'>
                                        <div
                                          class='img-1-1'
                                          style={{
                                            backgroundImage: `url(${encodeURI(
                                              item.item_img[0],
                                            )})`,
                                          }}
                                        />
                                      </div>
                                      <div class='col-8'>
                                        <div class='d-flex flex-column'>
                                          <h6 class='h6 mb-0'>
                                            {item.product_name}
                                          </h6>
                                          <div class='d-flex justify-content-between align-items-end mt-3'>
                                            <p class='h5 text-primary mb-0'>
                                              ${' '}
                                              {item.special_price !== '' &&
                                                item.special_price}
                                              {item.special_price === '' &&
                                                item.price}
                                            </p>
                                            <p class='p text-font mb-0'>
                                              /{item.pack}入
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            )
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            {isModalVisible && !isMobile && (
              <div
                className={styles['mask-wrapper']}
                onClick={this.handleCloseModal}>
                {currentPage !== totalPage && (
                  <div
                    className={styles['mask-right-icon']}
                    onClick={() => this.handleClickModalArrowBtn('next')}
                  />
                )}
                {currentPage !== 1 && (
                  <div
                    className={styles['mask-left-icon']}
                    onClick={() => this.handleClickModalArrowBtn('prev')}
                  />
                )}
                <div className={styles['close-btn']} />
                <div
                  id='modal-content-wrapper'
                  className={styles['modal-content-wrapper']}>
                  {!hasDoublePage && (
                    <Draggable disabled={!isDesktop}>
                      <div
                        className={styles['modal-image']}
                        style={{
                          width: this.getModalImage(currentSlide).width,
                          height: this.getModalImage(currentSlide).height,
                          flexBasis: '100%',
                          backgroundImage: `url(${currentSlide})`,
                          backgroundPosition: 'center',
                        }}
                      />
                    </Draggable>
                  )}
                  {hasDoublePage && (
                    <Draggable
                      disabled={!isDesktop}
                      position={{
                        x: modalImagePosition.x,
                        y: modalImagePosition.y,
                      }}
                      onStop={this.handleStopModalImage}>
                      <div class='d-flex'>
                        {currentSlide.map((imgURL, idx) => {
                          let width = this.getModalImage(imgURL).width
                          let height = this.getModalImage(imgURL).height
                          return (
                            <div
                              className={styles['modal-image']}
                              style={{
                                width,
                                height,
                                flexBasis: isDoublePage ? '50%' : '100%',
                                backgroundImage: `url(${imgURL})`,
                                backgroundPosition: isDoublePage
                                  ? null
                                  : 'center',
                              }}
                            />
                          )
                        })}
                      </div>
                    </Draggable>
                  )}
                </div>
                <div className={styles['operation-section']}>
                  <div className={styles['operation-bar-wrapper']}>
                    <div className='text-white mr-lg-5'>
                      {this.getSliderTipFormat(currentPage)}
                    </div>
                    <div
                      className={zoomOutBtnCx('zoomModalImg')}
                      onClick={() => this.handleZoomOut('zoomModalImg')}
                    />
                    <div
                      className={zoomInBtnCx('zoomModalImg')}
                      onClick={() => this.handleZoomIn('zoomModalImg')}
                    />
                    {showCategoryIdxBtn && (
                      <div style={{ marginLeft: '16px' }}>
                        {this.renderCategoryIdxBtn('modal')}
                      </div>
                    )}
                  </div>
                  <div className={styles['drawer-wrapper']}>
                    <Drawer
                      className={cx(styles['drawer'], styles['popup-mode'])}
                      placement='bottom'
                      visible={this.state.categoryIdxDrawerModal}
                      getContainer={false}
                      height={150}
                      bodyStyle={{ background: '#0870e6' }}
                      onClose={this.handleCloseDrawer}>
                      {this.renderDrawerList()}
                    </Drawer>
                  </div>
                </div>
              </div>
            )}
            {isModalVisible && isMobile && !isTabletLandscape && (
              <div
                className={styles['mask-wrapper']}
                onClick={this.handleCloseModal}>
                {showCategoryIdxBtn && !this.state.categoryIdxDrawerModal && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '10%',
                      left: '5%',
                      zIndex: 1100,
                    }}>
                    {this.renderCategoryIdxBtn('modal')}
                  </div>
                )}
                <div className={styles['close-btn']} />
                <div
                  className={styles['modal-content-wrapper']}
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Fragment>
                    <div
                      class='swiper-container-modal'
                      style={{
                        width: '100%',
                        height:
                          isMobilePortrait || isTabletPortrait
                            ? 'auto'
                            : '100%',
                      }}>
                      <div
                        class='swiper-wrapper h-100'
                        style={{ alignItems: 'center' }}>
                        {/* {catalogueInfo.images_previews.map((imgURL) => { */}
                        {/* 改原圖片 */}
                        {catalogueInfo.images.map((imgURL) => {
                          return (
                            <div
                              class='swiper-slide'
                              style={{
                                display:
                                  isTabletPortrait || isMobileLandscape
                                    ? 'flex'
                                    : 'inherit',
                                justifyContent: isMobileLandscape
                                  ? 'center'
                                  : 'inherit',
                              }}>
                              <div
                                class='catalogs-page-image'
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: isTabletPortrait
                                    ? 'auto'
                                    : isMobilePortrait
                                    ? '100%'
                                    : 'auto',
                                  height: isTabletPortrait
                                    ? 'auto'
                                    : isMobilePortrait
                                    ? 'auto'
                                    : '100%',
                                }}>
                                <img
                                  data-src={imgURL}
                                  alt=''
                                  class='swiper-lazy'
                                  style={{
                                    visibility: 'hidden',
                                    width: isTabletPortrait
                                      ? '85%'
                                      : isMobilePortrait
                                      ? '95%'
                                      : 'auto',
                                    height: isTabletPortrait
                                      ? 'auto'
                                      : isMobilePortrait
                                      ? 'auto'
                                      : '95%',
                                  }}
                                />
                                <div class='swiper-lazy-preloader' />
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      <div
                        className={styles['next-btn-wrapper']}
                        style={{
                          visibility:
                            currentPage !== totalPage
                              ? 'visible'
                              : 'hidden',
                        }}>
                        <div class='next-btn' />
                      </div>
                      <div
                        className={styles['prev-btn-wrapper']}
                        style={{
                          visibility:
                            currentPage !== 1 ? 'visible' : 'hidden',
                        }}>
                        <div class='previous-btn' />
                      </div>
                    </div>
                  </Fragment>
                </div>
                <div className={styles['operation-bar-wrapper']}>
                  <div className='text-white mr-lg-5'>
                    {this.getSliderTipFormat(currentPage)}
                  </div>
                </div>
                <div
                  className={styles['drawer-wrapper']}
                  style={{ zIndex: 1500 }}>
                  <Drawer
                    className={cx(styles['drawer'], styles['popup-mode'])}
                    placement='bottom'
                    visible={this.state.categoryIdxDrawerModal}
                    getContainer={false}
                    bodyStyle={{ background: '#0870e6' }}
                    onClose={this.handleCloseDrawer}>
                    {this.renderDrawerList()}
                  </Drawer>
                </div>
              </div>
            )}
            {isModalVisible && isMobile && isTabletLandscape && (
              <div
                className={styles['mask-wrapper']}
                onClick={this.handleCloseModal}>
                <div className={styles['close-btn']} />
                <div
                  className={styles['modal-content-wrapper']}
                  style={{
                    width: '100%',
                    height: isTabletLandscape ? 'auto' : '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Fragment>
                    <div
                      class='swiper-container-modal'
                      style={{
                        width: '100%',
                        height: isMobilePortrait ? 'auto' : '100%',
                      }}>
                      <div
                        class='swiper-wrapper h-100'
                        style={{
                          alignItems: 'center',
                        }}>
                        {catalogueInfo.imagesPreviewsDoublePage.map(
                          (imgArray) => {
                            return (
                              <div class='swiper-slide'>
                                <div
                                  class='catalogs-page-image h-100'
                                  style={{
                                    width: '90%',
                                    margin: '0 auto',
                                  }}>
                                  {imgArray.map((url, idx) => {
                                    return (
                                      <img
                                        data-src={url}
                                        alt=''
                                        class='swiper-lazy'
                                        style={{
                                          visibility: 'hidden',
                                          width: '50%',
                                          objectPosition:
                                            imgArray.length === 1
                                              ? 'center'
                                              : idx % 2 === 0
                                              ? 'right'
                                              : 'left',
                                        }}
                                      />
                                    )
                                  })}
                                  <div class='swiper-lazy-preloader' />
                                </div>
                              </div>
                            )
                          },
                        )}
                      </div>
                      <div
                        className={styles['next-btn-wrapper']}
                        style={{
                          visibility:
                            currentPage !== totalPage
                              ? 'visible'
                              : 'hidden',
                        }}>
                        <div class='next-btn' />
                      </div>
                      <div
                        className={styles['prev-btn-wrapper']}
                        style={{
                          visibility:
                            currentPage !== 1 ? 'visible' : 'hidden',
                        }}>
                        <div class='previous-btn' />
                      </div>
                    </div>
                  </Fragment>
                </div>
                <div className={styles['operation-bar-wrapper']}>
                  <div className='text-white mr-lg-5'>
                    {this.getSliderTipFormat(currentPage)}
                  </div>
                </div>
              </div>
            )}
            {/* 促銷目錄說明 Tooltip */}
            {isModalVisibleInfo && (
              <div
                className={styles['mask-wrapper']}
                onClick={this.handleCloseModal}>
                <div className={styles['close-btn']} />
                <InfoDetail />
              </div>
            )}
          </Fragment>
        )}
        {/* 增加iframe url 是否存在判斷 */}
        {iFrameUrl !== null && (
          <div class='container'>
            <section class='pt-md-5'>
              <div align='center'>
                <iframe
                  title='edm-iframe'
                  name='edm-iframe'
                  id='edm-iframe'
                  src={iFrameUrl}
                  style={{ minWidth: '100%', minHeight: '100%' }}
                  height='auto'
                  scrolling='yes'
                  frameborder='no'
                />
              </div>
            </section>
          </div>
        )}
        {!havePageinfo && iFrameUrl === null && (
          <div class='container'>
            <section class='pt-md-5'>
              {!isKiosk && pdf && (
                <a
                  id='pdf'
                  alt={catalogueInfo.name}
                  href={
                    pdf &&
                    pdf.replace('mppuni-prosperity', 'wwwuni-prosperity')
                  }
                  target='_blank'
                  rel='noopener noreferrer'>
                  {' '}
                  {__('PDF下載', 'cec-plugin-stores')}
                </a>
              )}
              <InfiniteScroll
                initialLoad={true}
                pageStart={0}
                loadMore={this.handleInfiniteOnLoad}
                hasMore={!this.state.loading && this.state.hasMore}
                // useWindow={false}
              >
                <div align='center'>
                  <List
                    grid={{
                      gutter: 16,
                      xs: 1,
                      sm: 1,
                      md: 1,
                      lg: 1,
                      xl: 1,
                      xxl: 1,
                    }}
                    dataSource={this.state.data}
                    renderItem={(image, idx) => (
                      <List.Item key={idx}>
                        <img
                          align='center'
                          src={image}
                          alt='目錄'
                          style={{
                            width: '100%',
                          }}
                        />
                      </List.Item>
                    )}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description='資料載入中...'
                        />
                      ),
                    }}>
                    {this.state.loading && this.state.hasMore && (
                      <div className='demo-loading-container'>
                        <Spin />
                      </div>
                    )}
                  </List>
                </div>
              </InfiniteScroll>
            </section>
          </div>
        )}
      </main>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export class CatalogueInfoEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();
  }
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/v1/catalogues/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/catalogues');
        return;
      }

      this.fillData(data);
    });
  };
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});

    return (
      <div className='vu-blocks-editor'>
        <h2>促銷目錄內容</h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/catalogues/catalogue-info.js